//pl波兰
export const pl = {
    //Pasek nawigacyjny
    "n1": "Dom",
    "n2": "Zamówienie",
    'n3': 'Transakcja',
    "n4": "Zespół",
    "n5": "mój",
    //klasa podpowiedzi
    't1': 'Wystąpił błąd',
    't2': 'Kopiowanie powiodło się',
    't3': 'Proszę uzupełnić informacje',
    't4': 'Ładowanie...',
    't5': 'Logowanie powiodło się',
    't6': 'Wynik musi być większy niż 3, aby zostać przesłanym',
    't7': 'Przesłanie zakończone sukcesem',
    't8': 'Niewystarczające saldo, brak możliwości odbioru',
    't9': 'Przesłanie nie powiodło się',
    't10': 'Najpierw powiąż adres, a zostaniesz przekierowany na stronę centrum osobistego',
    't11': 'Adres został powiązany, prosimy o kontakt z obsługą klienta w celu modyfikacji',
    't12': 'Modyfikacja udana',
    't13': 'Modyfikacja nie powiodła się',
    't14': 'Skontaktuj się z obsługą klienta w celu zmiany hasła',
    't15': 'Błąd formatu hasła',
    't16': 'Wypłata udana',
    "t17": "Maksymalna liczba wypłat",
    "t18": "Minimalna wypłata",
    't19': 'Dwa hasła są niespójne',
    "t20": "Podpowiedź",
    't21': 'Chwilowo nie można skoczyć',
    't22': 'Błąd formatu hasła',
    't23': 'Rejestracja udana',
    't24': 'Proszę podać numer kierunkowy',
    "t25": "Nigdy więcej",
    //zapisać się
    "l1": "Język",
    'l2': 'Proszę podać numer swojego konta',
    'l3': 'Proszę podać hasło',
    "l4": "pamiętaj",
    'l5': 'Zaloguj się',
    'l6': 'Przejdź do rejestracji',
    'l7': 'Brak konta',
    'l8': 'Numer telefonu komórkowego',
    "l9": "pseudonim",
    'l10': 'hasło',
    'l11': 'Potwierdź hasło',
    'l12': 'kod zaproszenia',
    'l13': 'Zarejestruj się',
    'l14': 'Mam już konto',
    'l15': 'Przejdź do logowania',
    'l16': 'Wprowadź hasło składające się z 6-16 cyfr',

    //pomoc
    'bz1': 'Pomoc',
    "bz2": "FAQ",
    'bz3': 'Zasady handlu',
    'bz4': 'Jak wypłacić pieniądze',
    'bz5': 'Jak doładować',
    'bz6': '1.Co to jest Amazon Review RoBoT?',
    "bz7": "Amazon Review RoBoT to firma zajmująca się marketingiem i promocją, która pomaga sprzedawcom w sklepach internetowych Amazon Review RoBoT na całym świecie uzyskać większą sprzedaż zamówień i zwiększyć ilość danych przeglądania sklepu internetowego Amazon Review RoBoT. Zależy nam na ustanowieniu trójstronnego, zyskownego modelu marketingu i promocji pomiędzy Amazon Review RoBoT, sprzedawcami i konsumentami. W połączeniu z najnowszą technologią blockchain P2P, konsumenci i sprzedawcy są szybko połączeni za pośrednictwem USDT (TRC20, ERC20). Zarejestrowani użytkownicy mogą otrzymywać prowizje od zamówień, a sprzedawcy mogą zwiększać dane sprzedażowe swojego sklepu. To najnowszy model zysku w internetowym modelu blockchain! ",
    'bz8': '2.Jak działa Amazon Review RoBoT?',
    'bz9': 'Codzienne informacje zwrotne z Amazon Review RoBoT pokazują, że produkty wymagające poprawy są sprzedawane w Amazon Review RoBoT. Użytkownicy muszą jedynie łatwo kliknąć zamówienie, a system automatycznie generuje subskrypcję zamówienia. Użytkownicy płacą kwotę zamówienia za pośrednictwem blockchain USDT i otrzymują dzienną prowizję. ',
    'bz10': '3.Dlaczego ceny tej samej waluty są różne w dwóch transakcjach? ',
    "bz11": "Różnice cenowe są spowodowane wszystkimi czynnikami, które nie sprzyjają swobodnemu obiegowi walut, w tym szybkością transferów walut, warunkami sieci, ograniczeniami w dostępie do waluty, rozpoznawaniem walut przez ludzi w różnych regionach, a nawet parami handlowymi dostarczane przez typy giełd, transakcje itp. Dlatego ta sama waluta może mieć różnice cenowe w różnych transakcjach. ",
    'bz12': '4. Zysk z inwestycji? ',
    'bz13': 'Im wyższą cenę produktu uzyskasz, tym większy zysk uzyskasz z zamówienia. Jednocześnie Amazon Review RoBoT losowo rozdziela duże zamówienia prowizyjne. ',
    'bz14': "System automatycznie generuje i rozsyła do użytkowników 60 zamówień produktów dziennie. Użytkownicy dokonują płatności za każde zamówienie za pośrednictwem USDT i otrzymują 0.6% prowizji. Duże zamówienia prowizyjne są przydzielane losowo. ",
    'bz15': "USDT można wypłacić po złożeniu 60 zleceń. (Jeżeli 60 zamówień nie zostanie zrealizowanych, system automatycznie zatrzyma się do czasu realizacji pozostałych zamówień danego dnia)",
    'bz16': 'Każde konto może być powiązane tylko z jednym kontem USDT. W przypadku wystąpienia błędu prosimy o kontakt z obsługą klienta',
    "bz17": "Po zrealizowaniu codziennych zamówień możesz normalnie wypłacić pieniądze. Dotrą one w ciągu 24 godzin od rozpoczęcia wypłaty i nie ma limitu wypłat",
    "bz18": "Przed doładowaniem powiąż swój adres wypłaty (obsługuje TRC-20) z adresem USDT. Możesz kliknąć Doładuj w aplikacji lub na stronie internetowej i wybrać łańcuch bloków (TRC-20), którego używasz do doładowania. ",
    'bz19': "Doładowanie lub przelewanie pieniędzy pomiędzy powiązanymi kontami jest niedozwolone. Jest to złośliwe przejmowanie zamówień i poważnie wpływa na zasady działania platformy. W przypadku wykrycia takiego zachowania system natychmiast zamrozi konto i zdyskwalifikuje pracę.",
    //tekst modułu
    //Pospolite słowa
    "ty1": "OK",
    "ty2": "Anuluj",
    "ty3": "Wyślij",
    "ty4": "Adres TRC20",
    "ty5": "Adres ERC20",
    //pierwsza strona
    "s1": "Skumulowany dochód",
    "s2": "Usługa",
    's3': 'O nas',
    "s4": "Pomoc",
    "s5": "Partner",
    's6': 'Mój serwis',
    //Zamówienie
    "d1": "Niedokończone",
    "d2": "Zakończono",
    'd3': 'Jeszcze brak danych',
    'd4': 'liczba nieparzysta',
    "d5": "Czas handlu",
    "d6": "kwota",
    'd7': 'Aktualna liczba zadań',
    "d8": "Oczekiwany zwrot",
    "d9": "Potrzebuję więcej",
    'd10': 'Ocena',
    //handel
    'j1': 'Saldo konta',
    "j2": "Wprowadzenie do handlu",
    "j3": "Recenzja RoBoT codziennie korzysta z informacji zwrotnych z recenzji RoBoT, aby pokazać produkty sprzedawane przez firmę Amazon Review RoBoT, które wymagają ulepszenia. Użytkownik musi jedynie kliknąć zamówienie, a system automatycznie wygeneruje podpis zamówienia. Użytkownicy płacą kwotę zamówienia za pośrednictwem łańcucha bloków USDT i za każdym razem mogą otrzymać ponad 0,6% prowizji, a system losowo rozdziela duże zamówienia z nagrodami. ",
    'j4': 'Rozpocznij dopasowywanie',
    'j5': 'Dzisiejsze zarobki',
    'j6': 'Numer ukończony',
    'j7': 'Całkowita liczba zadań',
    //zespół
    "td1": "Saldo",
    "td2": "prowizja",
    "td3": "Odbierz",
    'td4': 'Całkowita liczba osób',
    "td5": "użytkownik",
    "td6": "wkład",
    'td7': 'Ilość',
    "td8": "status",
    //Centrum osobiste
    'g1': 'Wypłata',
    "g2": "Naładuj",
    'g3': 'Zaproś znajomych',
    'g4': 'Zaproś teraz',
    'g5': 'Za każdy zysk, jaki Twój znajomy osiągnie po rejestracji, otrzymasz odpowiednią część prowizji',
    "g6": "Dane osobowe",
    'g7': 'Szczegóły funduszu',
    'g8': 'Rekord doładowania',
    'g9': 'Rekord wypłaty',
    'g10': 'Język',
    'g11': 'Wyloguj się',
    'g12': 'Czy na pewno chcesz się wylogować?',
    //Informacje użytkownika
    'yh1': 'Informacje o użytkowniku',
    "yh2": "Modyfikuj",
    "yh3": "ustawienie",
    "yh4": "telefon",
    'yh5': 'Czy na pewno chcesz się wylogować?',
    'yh6': 'Oryginalne hasło',
    'yh7': 'Nowe hasło',
    //Detale
    'mx1': 'Pobór prowizji',
    "mx2": "zysk",
    'mx3': 'Wypłata odrzucona',
    "mx4": "czas",
    'mx5': 'Doładowanie powiodło się',
    "mx6": "Odrzucono",
    "mx7": "oczekuje",
    'mx8': 'Adres wypłaty',
    'mx9': 'Dostępne saldo',
    "mx10": "Rzeczywiste przybycie",
    'mx11': 'Proszę podać kwotę wypłaty',
    //uzupełniać
    'cz1': 'Adres wpłaty obsługuje tylko ERC20, a minimalna kwota wpłaty to 20USDT',
    'cz2': 'Kopiuj',
    'cz3': 'Wybór waluty Fiata',
    'cz4': 'płatność',
    'cz5': 'Adres wpłaty obsługuje tylko TRC20-USDT, a minimalna kwota wpłaty to 20USDT',
    'cz6': 'Adres wpłaty obsługuje tylko ERC20, a minimalna kwota wpłaty to 20USDT',
    'cz1': 'Adres wpłaty obsługuje tylko ERC20, a minimalna kwota wpłaty to 20USDT',
    'cz1': 'Adres wpłaty obsługuje tylko ERC20, a minimalna kwota wpłaty to 20USDT',
    //obszar
    "qy1": "numer kierunkowy",
    'yq1': 'Zaproś znajomych',
    'yq2': 'kod zaproszenia',
    'yq3': 'Zaproś znajomych i ciesz się dużymi korzyściami',
    'yq4': 'Idź i zaproś',
    "zf1": "Metoda naładowania",
    "zf2": "Wybierz metodę ładowania",
    "zf3": "Waluta handlowa",
    "zf4": "Sieć handlowa",
    "zf5": "Przejdź do transakcji",
    "zf6": "Kopiuj pomyślnie",
    "zf7": "Waluta handlowa",
    "zf8": "Proszę użyć",
    "zf9": "Prześlij pieniądze na poniższy adres, aby ukończyć ładowanie.",
    "zf10": "Waluta handlowa",
    "zf11": "kopia",
    "zf12": "Proszę uważnie sprawdzić adres, błąd nie zostanie odzyskany",
    "zf13": "Czas przyjazdu",
    "zf14": "Około 1 do 5 minut",
    "zf15": "Minimalna kwota ładowania",
    "a1": "Centrum Marketingu Sklepu",
    "a2": "Centrum Marketingu Sklepu Amazon Market Robot to zupełnie nowa platforma zaprojektowana, aby pomóc sprzedawcom szybko zwiększyć sprzedaż produktów i liczbę pozytywnych recenzji, a tym samym zwiększyć ich widoczność i rozpoznawalność. Użytkownicy mogą pomagać sprzedawcom, wykonując różne zadania i otrzymując odpowiednie nagrody, tworząc sytuację korzystną dla obu stron",
    "a3": "Obecnie system ma 30 milionów użytkowników i 5 milionów sprzedawców, promujących 70 milionów produktów dziennie. Niektórzy sprzedawcy zwiększyli sprzedaż w swoich sklepach o 60%, integrując swoje produkty z systemem Centrum Marketingu. Użytkownicy platformy po prostu klikają zamówienie, a system automatycznie generuje podpis zamówienia. Po przedpłacie kwoty zamówienia transakcja wirtualna zostaje zakończona, a środki są natychmiast zwracane na konto użytkownika. Użytkownicy mogą za każdym razem zarabiać dodatkową prowizję w wysokości 0,6% lub więcej. System losowo przypisuje również duże zamówienia bonusowe, aby zwiększyć prowizje użytkowników",
    "a4": "Firma Amazon Market Robot przywiązuje dużą wagę do potrzeb użytkowników i sprzedawców, nieustannie optymalizując i udoskonalając system Centrum Marketingowego",
    // 客服
    "kf1": "Obsługa klienta online",
    "kf2": "Ręczna obsługa klienta wypłata",
    "kf3": "Możesz kliknąć tutaj, aby skontaktować się z ręczną obsługą klienta w sprawie wypłaty",
    "kf4": "Ręczna obsługa klienta doładowanie",
    "kf5": "Możesz kliknąć tutaj, aby skontaktować się z ręczną obsługą klienta w sprawie doładowania",
    // 支付选项弹窗
    "zf16": "W przypadku transakcji kartą bankową skontaktuj się z obsługą klienta",
    "zf17": "Skontaktuj się z obsługą klienta"
}
